///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.duplicate_vendor = abcsetup.duplicate_vendor || {};
abcsetup.duplicate_vendor.workflow = abcsetup.duplicate_vendor.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.duplicate_vendor.workflow = {
    // Variables
    workflow_task: null,
    disable_tab: true,

    /**
     *
     */
    init: function () {
        abcsetup.setTitle('Duplicate SAP Supplier');

        // Assign the local workflow_task var
        this.workflow_task = JSON.parse($('#WorkflowTask').val());

        // Apply and custom styles
        //this._applyStyles();

        $(document).on('click', '#csra-btn', function() {
            abcsetup.duplicate_vendor.common._toggleLicenses();
        })

        $('#vendorRoleUser').select2({
            width: '100%',
        });
        
        $('.dropdown-menu.reject').on('click', function(e) {
            e.stopPropagation();
        });
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        abcsetup.duplicate_vendor.common.bindFormElems();

        // Bind any form element behavior
        this._bindFormElems();
    },

    /**
     * Bind any form element behavior
     */
    _bindFormElems: function () {
        // Signature invite button
        $(document).on('click', '.btn-signature-invite', function() {
            var _link = $(this);
            _link.css("cursor", "progress");

            axios.post('/api/duplicate_vendor/send_signature', {
                'tag': _link.data('field-tag'),
                'column': _link.data('field-column'),
                'email': _link.closest('.row').find('input').val(),
                'workflow_task_id': abcsetup.duplicate_vendor.workflow.workflow_task.id,
            }).then(response => {
                _link.css('cursor', 'pointer');
                abcsetup.alerts.show('Signature Email Sent', 'We\'ve sent a signature request email to the address you specified.');
            });
        });
    },

    fieldError: function() {
        var errorField = $('form').find('.invalid').first();
        console.log(errorField.parent().html());
        abcsetup.unblockUI();
    }

}
